import React from 'react';
import Player from '../../containers/default/player';
import qs from 'qs';
import { useLocation, useParams } from 'react-router-dom';
import { VideoSpaceResourceId, SlideshowSpaceResourceId } from '../../common/constants/xr';
import { useSelector } from 'react-redux';
import { RootState } from '../../types/data';
import { MediaType } from '../../common/media';

const PlayerLayoutRoute = () => {
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { experienceId } = useParams<{ experienceId?: string }>();
  const { slideshowId } = useParams<{ slideshowId?: string }>();
  const experience = useSelector<RootState, RootState['experience']['current']>(state => state.experience.current);
  const slideshow = useSelector<RootState, RootState['slideshow']['current']>(state => state.slideshow.current);

  const isSlideshowPlayer = (experienceId && (!!experience.data?.tour || !!experience.data?.points) ) || (slideshowId && (!!slideshow.data?.tour || !!slideshow.data?.points) );

  const target = isSlideshowPlayer ? SlideshowSpaceResourceId : VideoSpaceResourceId;
  const type = isSlideshowPlayer ? MediaType.Slideshow : MediaType.Video;

  const mode = Number(query.mode);
  const playerMode = Number(query.playerMode);

  const showPlayer = playerMode === 2;
  const showAddons = mode === 3 || mode === 4;

  return <>{showPlayer ? <Player target={target} type={type} showAddons={showAddons} /> : null}</>;
};

export default PlayerLayoutRoute;
